<template>
    <v-col :cols="cols">
        <v-select
            v-model="selected"
            :items="items"
            :label="$t('lang_GENERIC_CAPTION_IMPORT')"
            @input="run"
            menu-props="offset-y, offset-overflow"
            :outlined="true"
            :hideDetails="true"
            :alvqa="alvqa + '-list-import-dropdown'"
            @change="additionalFunction(selected)"
            :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
            @click:clear="resetVal()"
        >
            <template v-slot:item="{ item }">
                <div :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
            <template v-slot:selection="{ item }">
                <div class="text-no-wrap text-truncate" :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
        </v-select>
    </v-col>    
</template>

<script>
import VSelect from 'vuetify/es5/components/VSelect'

export default {
    name: "ImportButton",
    extends: VSelect,
    props: {
        cols: {
            type: String | Number,
            default: "3"
        },
        alvqa: {
            type: String,
            default: ''
        },
        additionalFunction: {
            type: Function,
            default: () => {}
        },
        context: String,
        returnObject: {
            type: Boolean,
            default: false
        }

    },
    computed: {
        selected: {
            get() { return this.$store.getters['getSelected'+this.context] },
            set(selected) {
                if(this.$props.returnObject) {
                    this.$store.commit('setSelected'+this.context, this.items.find(item=>item.value === selected))
                    return
                }
                this.$store.commit('setSelected'+this.context, selected)
            }
        },
    },
    methods: {
        run() {

            // Mixpanel tracking
            let eventName;

    // Check if the current route is 'SalesData'
    if (this.$route.path === '/label/salesdata') {
        let selected = this.$store.getters.getSelectedFileImport;
        let options = this.$store.getters.getSalesDataImportOptions;
        let found = options.find(el => el.value === selected);

        eventName = found ? found.text : 'Unknown';
    } else {
        // For other contexts, use the existing logic
        eventName = this.$props.returnObject ? (this.selected ? this.selected.text : 'svd') : this.selected;
    }

    let importAction = 'Import > ' + eventName.charAt(0).toUpperCase() + eventName.slice(1);
    mixpanel.track(importAction, {
        'routePath': this.$route.path,
        'userId': this.$store.getters.getUser.id,
    });

            // do Import action
            this.$store.dispatch('do'+this.context)
        },
        async resetVal() {
            await this.$nextTick()
            this.selected = null
        }
    }
}
</script>